<template>
  <div class="flex">
    <button @click="acceptConnectRequest" style="margin-right: 5px;" class="acceptButton">
      {{ acceptingRequest ? "Accepting..." : "Accept request" }}
    </button>
    <button @click="rejectConnectRequest" class="rejectButton">
      {{ rejectingRequest ? "Rejecting..." : "Reject" }}
    </button>
  </div>
</template>

<script>
import profileAPIService from "../../../api/profileAPIService";

export default {
  name: "AcceptRejectButtons",
  props: {
    profileOwnerID: {
      type: String,
      required: true,
    },
    userID: {
      type: String,
      required: true,
    },
    connectionID: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      rejectingRequest: false,
      acceptingRequest: false,
    };
  },
  methods: {
    async acceptConnectRequest() {
      this.acceptingRequest = true;
      const result = await profileAPIService.acceptConnectRequest(this.connectionID, this.userID, this.profileOwnerID);
      if (result !== null) {
        console.log("NOICE!");
        result.action = "accept";
        this.$emit("updateConnectionStatus", result);
      } else {
        console.log("RIP");
        console.error("@acceptConnectRequest")
      }
      this.acceptingRequest = false;
    },

    async rejectConnectRequest() {
      this.rejectingRequest = true;
      const result = await profileAPIService.rejectConnectRequest(this.connectionID, this.userID, this.profileOwnerID);
      if (result !== null) {
        console.log("NOICE");
        result.action = "reject";
        this.$emit("updateConnectionStatus", result);
      } else {
        console.log("RIP");
        console.error("@rejectConnectRequest")
      }
      this.rejectingRequest = false;
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
</style>